import { useContext, useEffect, useState } from "react";
import { SettingsContext } from "../../Settings";
import { __ } from "@wordpress/i18n";
import HTMLReactParser from "html-react-parser";
import { ReactComponent as CircularArrows } from "../../assets/circular_arrows.svg";
import { ReactComponent as Loader } from "../../assets/loader.svg";
import { ajaxCall } from "../../Helpers/AjaxHelper";
import { setNotificationAction } from "../../Helpers/ReduxHelper";
import { useDispatch } from "react-redux";

const CachingSection = () => {
  const { register, settings, watch } = useContext(SettingsContext);
  const [isClearingCache, setIsClearingCache] = useState(false);
  const [currentInterval, setCurrentInterval] = useState(
    settings.cache_cron_interval
  );
  const dispatch = useDispatch();
  const interval = watch("cache_cron_interval");

  useEffect(() => {
    setCurrentInterval(interval);
    window.sby_settings.settings.cache_cron_interval = interval;
  });
  return (
    <div className="sb-tab-box sb-reset-box-style clearfix">
      <div className="tab-label">
        <h3>{__("Caching", "feeds-for-youtube")}</h3>
      </div>
      <div className="sby-tab-form-field">
        <div className="sb-form-field">
          <div className="d-flex mb-15">
            <select
              className="sby-select"
              {...register("cache_cron_interval")}
              defaultValue={settings.cache_cron_interval}
            >
              <option value="30mins">
                {__("Every 30 minutes", "feeds-for-youtube")}
              </option>
              <option value="1hour">
                {__("Every hour", "feeds-for-youtube")}
              </option>
              <option value="12hours">
                {__("Every 12 hours", "feeds-for-youtube")}
              </option>
              <option value="24hours">
                {__("Every 24 hours", "feeds-for-youtube")}
              </option>
            </select>
            {currentInterval !== "30mins" && currentInterval !== "1hour" && (
              <>
                <select
                  className="sby-select size-xs ml-1"
                  {...register("cache_cron_time")}
                  defaultValue={settings.cache_cron_time}
                >
                  <option value="1">{__("1:00", "feeds-for-youtube")}</option>
                  <option value="2">{__("2:00", "feeds-for-youtube")}</option>
                  <option value="3">{__("3:00", "feeds-for-youtube")}</option>
                  <option value="4">{__("4:00", "feeds-for-youtube")}</option>
                  <option value="5">{__("5:00", "feeds-for-youtube")}</option>
                  <option value="6">{__("6:00", "feeds-for-youtube")}</option>
                  <option value="7">{__("7:00", "feeds-for-youtube")}</option>
                  <option value="8">{__("8:00", "feeds-for-youtube")}</option>
                  <option value="9">{__("9:00", "feeds-for-youtube")}</option>
                  <option value="10">{__("10:00", "feeds-for-youtube")}</option>
                  <option value="11">{__("11:00", "feeds-for-youtube")}</option>
                  <option value="12">{__("12:00", "feeds-for-youtube")}</option>
                </select>
                <select
                  className="sby-select size-xs ml-1"
                  {...register("cache_cron_am_pm")}
                  defaultValue={settings.cache_cron_am_pm}
                >
                  <option value="am">{__("AM", "feeds-for-youtube")}</option>
                  <option value="pm">{__("PM", "feeds-for-youtube")}</option>
                </select>
              </>
            )}
            <button
              className={`sby-btn sb-btn-lg sb-btn-grey ml-1 ${
                isClearingCache ? "loading" : ""
              }`}
              onClick={(evt) => {
                evt.preventDefault();
                setIsClearingCache(true);
                ajaxCall("sby_clear_cache")
                  .then(() => {
                    dispatch(
                      setNotificationAction(
                        __("Cache cleared successfully.", "feeds-for-youtube")
                      )
                    );
                  })
                  .catch(() => {
                    dispatch(
                      setNotificationAction(
                        __("Couldn't clear the cache.", "feeds-for-youtube"),
                        "error"
                      )
                    );
                  })
                  .finally(() => {
                    setIsClearingCache(false);
                  });
              }}
            >
              {!isClearingCache && <CircularArrows />}
              {isClearingCache && <Loader />}

              <span className="pl-2">
                {__("Clear All Caches", "feeds-for-youtube")}
              </span>
            </button>
          </div>
          <div className="help-text help-text-green">
            {HTMLReactParser(window.sby_settings.next_cron)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CachingSection;
